// extracted by mini-css-extract-plugin
module.exports = {"main":"RegisterBody_main__3VGUc","content":"RegisterBody_content__1RWix","left":"RegisterBody_left__O0elN","right":"RegisterBody_right__KrAfh","image":"RegisterBody_image__2eqwa"};